export const PAGE_LOADED = {
  event: 'page_loaded'
}

export const PAGE_VIEW = {
  event: 'page_view'
}

export const MAP_INIT = {
  event: 'map_init'
}

export const POI_VIEW = {
  event: 'poi_view'
}

export const TAB_VIEW = {
  event: 'tab_view'
}

export const POI_ACTION = {
  event: 'poi_action'
}

export const VIDEO_PLAY = {
  event: 'poi_video_play'
}
